module.exports = __webpack_public_path__ + "img/selfieFbShare.db9b4e15.svg";